module.exports = __webpack_public_path__ + "static/media/IconMenu.cb16ed77.svg";